// Module
var code = "<div [ngStyle]=\"outerStyle\" style=\"overflow:hidden\"> <div [ngStyle]=\"marginTopStyle\"> <div [ngStyle]=\"transformStyle\"> <div style=\"background-repeat:no-repeat;background-blend-mode:multiply\" [ngStyle]=\"innerStyle\"> </div> </div> </div> </div> ";
// Exports
export default code;